import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupService } from '../services';

@Pipe({
  name: 'userAvatar',
})
export class UserAvatarPipe implements PipeTransform {
  private defaultObs = of(this.lookupSvc.defaultAvatar);

  constructor(private lookupSvc: LookupService) {}

  transform(userId?: number | null, large?: boolean): Observable<SafeUrl> {
    if (userId === 0 || !userId) return this.defaultObs;
    if (!!large) {
      return this.lookupSvc
        .largeAvatar$(userId)
        .pipe(map((a) => a || this.lookupSvc.defaultAvatar));
    } else {
      return this.lookupSvc
        .smallAvatar$(userId)
        .pipe(map((a) => a || this.lookupSvc.defaultAvatar));
    }
  }
}
